module.exports = __webpack_public_path__ + "img/logo.b9575924.jpg";